// Auto-generated by scripts/bump-version.js on build — do not edit manually
export const APP_VERSION = "1.0.10";
